
<template>
  <div class="cores">
    <template>
      <v-card>
        <v-card-title>
          Payment Processor Config
        </v-card-title>
        <v-container fluid>
              <v-row name="select-core-row" align="center">
              <v-col name="select-core-col" class="d-flex" cols="2" sm="6">
                <v-select
                  :items="fiCores"
                  @change="selectCore(coreChosen)"
                  v-model="coreChosen"
                  label="Select Core"
                ></v-select>
              </v-col>
            </v-row>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredFiData"
          :loading="loading"
          :items-per-page="10"
          class="elevation-2"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.core }}</td>
            <td>{{ props.item.fiid }}</td>
            <td>

              <v-btn color="info" dark @click="editItem(props)">
                <font-awesome-icon icon="edit" class="pr-1" />Edit
              </v-btn>

            </td>
          </template>


        </v-data-table>
        </v-container>
      </v-card>
    </template>
    <v-dialog v-model="dialog" persistent max-width="1250px">
      <template v-slot:activator="{ on }">
        <v-btn @click="newItem()" color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
      </template>
      <v-card>
        <div v-if="this.newItemCheck">
        <v-card-title>
          <span class="headline">New Item</span>
        </v-card-title>
        </div>
        <v-tabs
          slider-size="4"
          height="58"
          v-model="selectedTab"
        >
          <v-tab>
            CORE CONFIG
          </v-tab>
          <v-tab>
            PRODUCT MAPPINGS
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="selectedTab" class="scrollableCard">
          <v-tab-item
            eager
          >
            <v-card-text>
              <v-container>
                <v-row name="item-form">
                  <v-col name="item-form-core-field" cols="12" sm="6" md="4">
                    <v-text-field
                    :disabled="newItemCheck==false"
                    :rules="['Required']"
                    v-model="editedItem.core"
                    label="Core">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.fiid"
                      label="FI ID"
                      :disabled="newItemCheck==false"
                      type="number"
                      :rules="['Required']"
                      :persistent-hint="true"
                      :hint="fiIdDescription"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.username" label="Username"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.password" label="Password"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field :rules="['Required']"
                    v-model="editedItem.institutionRoutingId"
                    label="Routing ID (Generally 9 digits)"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
                  <template v-for="(entry, productMappingIndex) in this.editedItem.productMappings">
                    <v-container v-bind:key="productMappingIndex">
                      <div class="innerTable">
                        <v-row>
                          <v-col>
                          <td><v-text-field label="Product Name"
                          :rules="['Required']"
                          v-model="entry.productName"/></td>
                          <td><v-btn @click="deleteProduct(productMappingIndex)" >DELETE PRODUCT</v-btn></td>
                          <td>
                            <v-checkbox label="Is Multilevel" v-model="entry.isMultipleLevel"/>
                            <v-select label="Max Level"
                              :items="[2,3]" v-model="entry.maxLevel" v-if="entry.isMultipleLevel" :rules="['Required']"></v-select>
                          </td>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-row>
                              <div v-for="(mapping, index) in entry.qualToNonQualProductMappings" v-bind:key="index">
                                <tr>
                                  <td><v-text-field :label="getProductQualCodeLabel(entry)" :rules="['Required']"
                                    v-model="mapping.qualProductCode"/></td>
                                  <td><v-text-field label="Non Qual Product Code"
                                    v-model="mapping.nonQualProductCode" :rules="['Required']"/></td>
                                  <td >
                                  <td v-if="entry.isMultipleLevel && entry.maxLevel > 1"><v-text-field label="Principal Product Code"
                                    v-model="mapping.qualLevelOneProductCode" :rules="['Required']"/></td>
                                  <td >
                                  <td v-if="entry.isMultipleLevel && entry.maxLevel > 2"><v-text-field label="Enhanced Product Code"
                                    v-model="mapping.qualLevelTwoProductCode" :rules="['Required']"/></td>
                                  <td >
                                    <v-btn @click="deleteProductMapping(entry, index)">DELETE MAPPING</v-btn>
                                  </td>
                                </tr>
                              </div>
                          </v-row>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn @click="addProductMapping(entry)">ADD NEW MAPPING</v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-container>
                  </template>
                  <v-btn @click="addNewProduct">ADD NEW PROUCT</v-btn>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import PaymentProcessorService from '@/PaymentProcessorService';

@Component()
export default class PaymentProcessorConfig extends Vue {
  /*eslint-disable */
  data() {
    return {
      menu: false,
      dialog: false,
      selected: [],
      newItemCheck: false,
      filteredFiData: [],
      selectedCore: "",
      coreChosen: "",
      fiCores: [],
      fiIdDescription:
        "This field must consist of numbers only (generally 4 digits)",
      checkingProductCodeDescription: "Default nonqual checking product code",
      savingsProductCodeDescription: "Default nonqual savings product code",
      selectedTab: null
    };
  }
  /* eslint-enable */

  coreNames = [];

  editedItem = PaymentProcessorService.createEmptyJhaUserConfig();

  loading = false;

  headers = [
    {
      text: 'Core Name',
      value: 'item',
      sortable: true,
      align: 'left',
    },
    {
      text: 'FI ID',
      sortable: true,
      align: 'left',
    },
    {
      text: 'Actions',
      value: 'action',
      sortable: false,
    },
  ];

  newItem() {
    this.newItemCheck = true;
    this.editedItem = PaymentProcessorService.createEmptyJhaUserConfig();
  }

  async changedCoreValue(core) {
    this.editedItem.core = core;
  }

  close() {
    this.dialog = false;
    this.selectedTab = 0;
    setTimeout(() => {
      this.editedItem = Object.assign({}, PaymentProcessorService.createEmptyJhaUserConfig());
    }, 300);
  }

  addProductMapping(productMapping) {
    if (!productMapping.qualToNonQualProductMappings) {
      productMapping.qualToNonQualProductMappings = [];
    }
    productMapping.qualToNonQualProductMappings.push({ qualProductCode: '', nonQualProductCode: '' });
  }

  deleteProductMapping(productMapping, index) {
    productMapping.qualToNonQualProductMappings.splice(index, 1);
  }

  addNewProduct() {
    if (!this.editedItem.productMappings) {
      this.editedItem.productMappings = [];
    }
    this.editedItem.productMappings.push({
      productName: '',
      isMultipleLevel: false,
      qualToNonQualProductMappings: [],
    });
  }

  deleteProduct(index) {
    this.editedItem.productMappings.splice(index, 1);
  }

  async editItem(fi) {
    this.newItemCheck = false;
    this.dialog = true;
    this.editedItem = await PaymentProcessorService.getPaymentProcessorRecord(fi.item.fiid);
    this.selectedCore = fi.item.core;
  }


  save() {
    PaymentProcessorService.addPaymentProcessorFi(this.editedItem).then(() => {
      this.close();
    }).catch((error) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.loading = false;
    });
  }

  showErrorMessage(error) {
    let errorMessage = '';
    if (error.response && error.response.data && error.response.data.entity) {
      errorMessage = error.response.data.entity;
    } else {
      errorMessage = 'An unexpected error occurred.';
    }
    const al = new Alert(errorMessage, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  async mounted() {
    this.loading = true;
    this.fiData = await PaymentProcessorService.getPaymentProcessorTable();
    this.filterCores(this.fiData);
    this.loading = false;
  }

  filterCores(fiData) {
    const cores = fiData.map(data => data.core);
    this.fiCores = [...new Set(cores)];
  }

  selectCore(coreChosen) {
    this.filteredFiData = this.fiData.filter(fi => fi.core === coreChosen);
  }

  getProductQualCodeLabel(entry) {
    if (entry.maxLevel > 2) {
      return 'Premium Product Code';
    }

    if (entry.maxLevel == 2) {
      return 'Enhanced Product Code';
    }

    return 'Principal Product Code';
  }
}
</script>


<style lang="scss">
 .innerTable {
   border: 1px solid #cfcfcf;
 }
</style>
